export default __webpack_public_path__ + "static/media/5.513625b9.jpg";